module.exports = __webpack_public_path__ + "img/how-it-works-mobile-desktop.b762a0c2.png";